export default "__VITE_ASSET__Xfypf513__"